import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Channel form schema (T11). `name` is required (inline "Name this channel"),
 * mirroring the onboarding required-message tone; `url` is an optional string.
 * Both stay `Yup.string()` so the page can rebuild the original conditional
 * payload (always `name`, `url` only when non-empty). Server 400 field errors
 * still map back onto the inputs via the Form's `showServerErrors`.
 */
const channelSchema = createSchema({
  name: Yup.string().required('Name this channel'),
  url: Yup.string(),
});


/** Map a channel record onto the form's string-valued shape. */
function channelDefaults(channel) {
  return {
    name: channel?.name || '',
    url: channel?.url || '',
  };
}


/**
 * eBay connection rename schema (Plan 3, Slice E). `label` is a free-text
 * nickname so multiple eBay accounts are distinguishable on the part Listings
 * tab; required (an empty label would defeat the purpose) and capped at 64 to
 * mirror the backend `IntegrationConnectionSerializer` max. Server 400 field
 * errors map back onto the input via the Form's `showServerErrors`.
 */
const connectionRenameSchema = createSchema({
  label: Yup.string().trim().required('Name this account').max(64, 'Keep it under 64 characters'),
});


/** Map a connection record onto the rename form's string-valued shape. */
function connectionRenameDefaults(connection) {
  return {
    label: connection?.label || connection?.external_account || '',
  };
}


export {
  channelDefaults,
  channelSchema,
  connectionRenameDefaults,
  connectionRenameSchema,
};
